<template lang="html">
    <BaseWidget :no-footer="true" v-show="areActionsRequired && !gettingActions">
        <template slot="title"
            >Forecasts</template
        >
        <template slot="content-desktop"
            ><RequiredActionsWidget
                :show-spinner="false"
                @areActionsRequired="
                    areActionsRequired = $event;
                    gettingActions = false;
                "
        /></template>
        <template slot="content-mobile"
            ><RequiredActionsWidget
                :show-spinner="false"
                @areActionsRequired="
                    areActionsRequired = $event;
                    gettingActions = false;
                "
        /></template>
    </BaseWidget>
</template>

<script lang="js">
import BaseWidget from "@/components/dashboard/BaseWidget";
import LinkButton from "@/components/dashboard/elements/LinkButton";
import { ROUTES } from "@/components/forecasts/router";
import RequiredActionsWidget from "@/components/forecasts/elements/widgets/RequiredActionsWidget";

export default  {
    components: { RequiredActionsWidget, LinkButton, BaseWidget},
    data(){
        return {
            areActionsRequired: null,
            gettingActions: true
        }
    },
    computed: {
        link (){
            return ROUTES.BASE
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
</style>



// WEBPACK FOOTER //
// ForecastWidget.vue?56ee586e